import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from "vuetify/src/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#ff6f00",
        secondary: "#424242",
        accent: "#76ff03",
        error: "#D50000",
        warning: "#FF8F00",
        info: "#448aff",
        success: "#43a047",
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
});
